var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcDismiss24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.03 5.03a.75.75 0 0 0-1.06-1.06L10 8.94 5.03 3.97a.75.75 0 0 0-1.06 1.06L8.94 10l-4.97 4.97a.75.75 0 1 0 1.06 1.06L10 11.06l4.97 4.97a.75.75 0 1 0 1.06-1.06L11.06 10l4.97-4.97Z",
  fill: "#8B97A7"
})));
export default SvgIcDismiss24;